import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=11db1ca4"
import script from "./Mark.vue?vue&type=script&lang=js"
export * from "./Mark.vue?vue&type=script&lang=js"
import style0 from "./Mark.vue?vue&type=style&index=0&id=11db1ca4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports